import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXMortgageQuoteThankYou implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxMortgageQuoteThankYouContainer";
    }
    render(){
        // console.log("thank you");

    }
}